import { render } from "./AdminLoginLayout.vue?vue&type=template&id=56777e26"
const script = {}

import "./AdminLoginLayout.vue?vue&type=style&index=0&id=56777e26&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__